//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import {Form, FormItem, Input, Divider, Tag, DatePicker, TimeSelect, Select, Option, Col, Button, Upload, Checkbox} from 'element-ui'
import CyMobileLayout from '../../../components/mobile/CyMobileLayout'
import CySelect from '../../../components/select/CySelect'
import CyAutocomplete from '../../../components/autocompletes/CyAutocomplete'
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Divider)
Vue.use(Tag)
Vue.use(Select)
Vue.use(Option)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(Button)
Vue.use(Upload)
Vue.use(Checkbox)
export default {
  name: 'StockOutPlanConfirm',
  components: {
    CyMobileLayout,
    CySelect,
    CyAutocomplete
  },
  data () {
    return {
      planId: this.$route.query.planId,
      confirm_status: '',
      baseInfo: {},
      stockOut: {stockio_plan_id: '', confirm_plan_date: '', planDate: '', planTime: '', stockio_amount: ''}, // 入库信息
      dateList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      let that = this
      let url = '/wms/stockout/plan/getStockOutPlanDateInfo'
      that.$axiosWeb.post(url, null, {params: {planId: that.planId}}).then(function (res) {
        if (res.meta.success) {
          // 剩余未确认任务
          that.stockOut.confirm_plan_date = res.data.baseInfo.export_date
          that.stockOut.planDate = res.data.baseInfo.export_date
          that.stockOut.total_amount = res.data.amount
          that.stockOut.stockio_amount = res.data.remain_amount
          // 已确认时间计划列表
          that.dateList = res.data.dateList
          that.stockOut.stockio_plan_id = res.data.baseInfo.stockout_plan_id
          that.confirm_status = res.data.baseInfo.confirm_status
        }
      })
    },
    submitConfirm: function () {
      let that = this
      that.$refs.mainFrm.validate((valid) => {
        if (valid) {
          that.stockOut.confirm_plan_date = that.stockOut.planDate + ' ' + that.stockOut.planTime + ':00'
          let url = '/wms/stockout/plan/confirmStockOutPlan'
          let stockOutParam = {}
          if (that.$Utils.IsEmpty(that.stockOut.stockio_amount)) {
            that.$Msgbox.alert('请填写数量')
            return false
          }
          if (that.stockOut.stockio_amount < 1) {
            that.$Msgbox.alert('数量必须大于0')
            return false
          }
          stockOutParam.stockOut = that.stockOut
          that.$axiosWeb.post(url, stockOutParam).then(function (res) {
            if (res.meta.success) {
              that.$Msgbox.alert('确认成功', '确认成功')
              location.href = '/wx/wms/stockOutPlanConfirm?planId=' + that.planId
            } else {
              that.$Msgbox.alert(res.meta.message, '确认失败')
            }
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wms/stockout/StockOutPlanConfirm.vue